(function(app) {

    app.provider("portalApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    service.launchiPipelineSso = function () {
                        return complianceHubApiGateway.get("/Portal/IComplyAppSso");
                    };
                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line